<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="80">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="工单号" prop="orderNo">
                        <Input disabled v-model="info.orderNo" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="原执行人" prop="oldExecUserId">
                        <form-lookup disabled v-model="info.oldExecUserId"
                            placeholder
                            title="选择执行人员"
                            textSymbol="nickname"
                            :modalHeight="540"
                            :modalWidth="800"
                            :options.sync="oldExecOptions">
                            <select-inside></select-inside>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="新执行人" prop="execUserId">
                        <form-lookup v-model="info.execUserId"
                            placeholder
                            title="选择执行人员"
                            textSymbol="nickname"
                            :modalHeight="540"
                            :modalWidth="800"
                            :options.sync="execOptions">
                            <select-inside></select-inside>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { orderView, changeExec } from '@/api/order-manage'
import SelectInside from '_vc/select-inside'
import { ymdL } from '_u/helper'

export default {
    name: 'FormOrderWaitExecute',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {
        SelectInside
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                id: this.id,
                orderNo: '',            // 工单号
                serviceType: '',        // 服务类型
                planCompleteTime: '',   // 要求完成时间
                orderStatus: '',        // 工单状态
                execUserId: '',         // 执行人员
                oldExecUserId: '',      // 原执行人
                ver: ''                 // 版本号
            },
            execOptions: [],
            oldExecOptions: []
        }
    },

    computed: {
        ruleValidate() {
            return {
                orderNo: [{ required: true, message: '工单号必填' }]
            }
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return orderView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([this.fetch()])
                .then(args => {
                    var [view] = args

                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                        this.info.planCompleteTime = ymdL(viewData.planCompleteTime);
                        this.info.oldExecUserId = viewData.execUserId
                        // 新执行人
                        this.execOptions.push({
                            id: viewData.execUserId,
                            nickname: viewData.execUserName
                        })
                        // 原执行人
                        this.oldExecOptions.push({
                            id: viewData.execUserId,
                            nickname: viewData.execUserName
                        })
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    return changeExec(formData)
                })
                .then(res => {
                    this.$Message.success(this.$t('tips.save.success'))
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
